<template>
  <div class="pt-4">
    <div class="row mb-4">
      <div class="col-12 text-center">
        <h3 class="font-weight-bolder">FAQ's</h3>
      </div>
    </div>
    <div class="row mb-4 faq align-content-center">
      <div class="col-12 text-center">
        <img
          src="https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fwww.greenbriarcolony.com%2Fwp-content%2Fuploads%2F2016%2F03%2Fconstruction-at-work-icon.png&f=1&nofb=1"
          class="img-fluid"
          style="width:10em;"
        />
        <br />
        <br />
        <h5>This Page will be available soon!!</h5>
      </div>
    </div>
    <LoaderGif :disable="loading" :success="success" :message="message" />
  </div>
</template>

<script>
import axios from "axios";
import { domain } from "@/store/variable";
import LoaderGif from "./LoaderGif.vue";

export default {
  name: "faq",
  components: {
    LoaderGif
  },

  data() {
    return {
      content: [],
      loading: false,
      success: false,
      message: null
    };
  },

  // beforeRouteEnter(to, from, next) {
  //   let url = domain + "faq";
  //   axios
  //     .get(url, {
  //       params: {
  //         name: to.params.name
  //       }
  //     })
  //     .then(res => {
  //       res.data.forEach(doc => {
  //         next(vm => {
  //           if (to.params.name == "termsandcondition") {
  //             vm.heading = "Terms and Conditions";
  //           } else if (to.params.name == "privacypolicy") {
  //             vm.heading = "Privacy Policy";
  //           } else if (to.params.name == "faq") {
  //             vm.heading = "About US";
  //           }
  //           vm.content = doc;
  //         });
  //       });
  //     })
  //     .catch(err => {
  //       console.log(err.message);
  //     });
  // },

  watch: {
    $route: "fetchContent"
  },

  methods: {
    fetchContent() {
      this.loading = true;
      let url = domain + "faq";
      axios
        .get(url)
        .then(res => {
          res.data.forEach(doc => {
            this.content = doc;
            this.loading = false;
          });
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.faq {
  height: 60vh;
  overflow: auto;
}

.faq h1,
.faq h2,
.faq h3,
.faq h4,
.faq h5,
.faq h6 {
  font-size: 1.1 rem;
  font-weight: normal;
  color: #2c211e;
}

.faq strong {
  color: #2c211e;
}

.faq {
  font-family: "Poppins";
  font-size: 1 rem;
  line-height: 1 em;
  color: #606c71;
}
</style>



// WEBPACK FOOTER //
// src/components/faq.vue